module.exports = __webpack_public_path__ + "img/premium-offer.e761ca3e.png";